<template>
    <div>
        <!-- Componente de criacao da solicitacao -->
        <FormSolicitacao @on-changed="onChangeForm" :formSolicitacao="formSolicitacao"/>
        <v-row>
            <v-col cols="12" sm="4" md="6" class="text-center">
                <v-btn @click.prevent="solicitar" small color="primary" class="my-1"
                    :loading="StateSolicitacoesLoading">
                    Solicitar
                </v-btn>
            </v-col>
        </v-row>
        <loading-gdb :dialog="StateSolicitacoesLoading"/>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FormSolicitacao from './FormSolicitacao.vue'
export default {
    name: 'IDSecureSolicitar',
    components:{
        FormSolicitacao
    },
    data:()=>({
        formSolicitacao:{
            foto:null,
            date_expire:null,
            time_expire:null,
            name:null,
            cpf:null,
        },
        rules:[ v => !!v || 'Campo Obrigatório'],
    }),
    mounted(){
    },
    methods:{
        ...mapActions(['CreateSolicitacaoVisitante']),
        onChangeForm(value){
            this.formSolicitacao = value
        },
        async solicitar(){
            if (!this.formSolicitacao.time_expire){
                this.formSolicitacao.time_expire = '23:59'
            }
            /* ignorar falta da foto e obrigar na aprovação */
            // if (!this.formSolicitacao.foto){
            //     alert('Cadastro sem foto! Por favor, cadastre uma foto para identificação no sistema.')
            // }
            else if (!this.formSolicitacao.date_expire){
                alert('Data limite de acesso não informada. A data é o período máximo que o visitante poderá acessar.(Passível de aprovação caso o período seja superior a 2 dias')
            }
            else if (!this.formSolicitacao.name){
                alert('Informe um nome e sobrenome do visitante para melhor identificação')
            }
            else if (!this.formSolicitacao.cpf){
                alert('Necessário informar um nº de documento, CPF ou RG')
            }else{
                const response = await this.CreateSolicitacaoVisitante(this.formSolicitacao)
                this.$emit('on-created', response.status == 201) // retornar booleando se foi criado (true ou false)
                if (response.status == 201){
                    this.formSolicitacao = Object.assign({},{
                        foto:null,
                        date_expire:null,
                        time_expire:null,
                        name:null,
                        cpf:null,
                    })
                }else{
                    console.error(response)
                }
            }
        }
    },
    computed:{
        ...mapGetters(['StateSolicitacoesLoading']),
    },
}
</script>